import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Row, Col, Button, Input, Modal, Skeleton, Tabs, Space, DatePicker } from "antd";
import dayjs from "dayjs";
import Select from "react-select";

let BASE_STATE_JOB = { name: null, comments: "", item: null, items_xref: null, job_status: null, job_statuses_xref: null, promised_by: null, form_due_date: null, clients_xref: null };

/*
Prop api
open: boolean, 
client_id: int,
refresh: function
*/

function ModalEditJob(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalWidth, setModalWidth] = useState(1200);

  const [job, setJob] = useState(BASE_STATE_JOB);

  const [company, setCompany] = useState(null);
  const [client, setClient] = useState(null);
  const [items, setItems] = useState([]);
  const [jobStatuses, setJobStatuses] = useState([]);

  const focusFirst = useRef(null);

  const GetClient = async () => {
    if (!props?.editJobProps?.client_id) return;
    let response = await props.AxiosRequest("/api/clients/get", { cid: props.editJobProps.client_id });
    setClient(response.data.client);
  };
  const GetJob = async (id) => {
    if (!props?.editJobProps?.job_id) return;
    let response = await props.AxiosRequest("/api/job/get", { id: props?.editJobProps?.job_id });
    let found_item = items.find((f) => f.id === response.data?.job?.items_xref);
    let found_status = jobStatuses.find((f) => f.id === response.data.job.job_statuses_xref);
    setJob({ ...response.data.job, promised_by: dayjs(response.data.job.promised_by), item: found_item, job_status: found_status });
  };
  const GetCompany = async () => {
    let response = await props.AxiosRequest("/api/companies/get");
    setCompany(response.data.company);
    BASE_STATE_JOB.promised_by = dayjs().add(response.data.company.default_job_days_due, "day");
  };
  const GetItems = async () => {
    let response = await props.AxiosRequest("/api/items/get");
    setItems(
      response.data.items.map((m) => {
        return { ...m, label: m.name, value: m.id };
      }),
    );
  };
  const GetJobStatuses = async () => {
    let response = await props.AxiosRequest("/api/job-statuses/get");
    setJobStatuses(
      response.data.job_statuses.map((m) => {
        return { ...m, label: m.name, value: m.id };
      }),
    );
  };
  const UpdateJob = async () => {
    if (job.name.length === 0) return props.MakeNotification("info", "Please enter the job name.");
    if (!job.items_xref || !job.name || !job.job_statuses_xref || !job.promised_by) return props.MakeNotification("info", "Please make fill in all required fields.");
    await props.AxiosRequest("/api/jobs/update", { ...job });
    props.setEditJobProps({ ...props.editJobProps, open: false, refresh: true });
  };

  useEffect(() => {
    const resize = () => {
      const maxSize = Math.min(900, window.innerWidth);
      setModalWidth(maxSize);
    };
    window.addEventListener("resize", resize);
  });

  useEffect(() => {
    if (props.editJobProps.open && props.editJobProps.client_id) GetClient();
    if (props.editJobProps.open && props.editJobProps.job_id) GetJob();
    setModalOpen(props.editJobProps.open);
  }, [props.editJobProps.open, props.editJobProps.client_id, props.editJobProps.job_id]);

  useEffect(() => {
    GetItems();
    GetJobStatuses();
    GetCompany();
  }, []);

  return (
    <>
      <Modal
        afterOpenChange={(open) => open && focusFirst.current?.focus()}
        title={"Edit Job"}
        centered
        destroyOnClose={true}
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
          setJob(BASE_STATE_JOB);
          props.setEditJobProps({ ...props.editJobProps, open: false, client_id: null });
        }}
        footer={
          <>
            <Button
              onClick={() => {
                setModalOpen(false);
                setJob(BASE_STATE_JOB);
                props.setEditJobProps({ ...props.editJobProps, open: false, client_id: null });
              }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={UpdateJob}>
              Update
            </Button>
          </>
        }
        width={modalWidth}
      >
        {job ? (
          <Row gutter={[{ xs: 8, sm: 16, md: 16, lg: 16 }, 8]}>
            <Col span={12}>
              <label className="col-form-label-sm">Job Name *</label>
              <Input
                ref={focusFirst}
                value={job.name}
                placeholder="Bookkeeping, 1040, Quarterly Report, etc"
                onChange={(e) => {
                  setJob({ ...job, name: e.target.value });
                }}
              />
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm">Item *</label>
              <Select
                value={job.item}
                options={items}
                onChange={(e) => {
                  setJob({ ...job, item: e, items_xref: e.value });
                }}
              />
            </Col>
            <Col span={24}>
              <label className="col-form-label-sm">Comments</label>
              <Input.TextArea
                value={job.comments}
                onChange={(e) => {
                  setJob({ ...job, comments: e.target.value });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm">Job Status *</label>
              <Select
                value={job.job_status}
                options={jobStatuses}
                onChange={(e) => {
                  setJob({ ...job, job_status: e, job_statuses_xref: e.value });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm">Due Date *</label>
              <DatePicker
                format={"MM/DD/YYYY"}
                style={{ width: "100%" }}
                allowClear={false}
                value={job?.promised_by ? dayjs(job?.promised_by) : null}
                onChange={(e) => {
                  setJob({ ...job, promised_by: e });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm">Form Due Date</label>
              <DatePicker
                format={"MM/DD/YYYY"}
                style={{ width: "100%" }}
                value={job?.form_due_date ? dayjs(job?.form_due_date) : null}
                onChange={(e) => {
                  setJob({ ...job, form_due_date: e });
                }}
              />
            </Col>
          </Row>
        ) : (
          <Skeleton active />
        )}
      </Modal>
    </>
  );
}

export default ModalEditJob;
